import { FiltersCalendarContainer } from 'app/imports/App.components'
import {
  getFiltersHasMultipleIds,
  selectWidgetTitle,
  selectWidgetTitleFontSize,
  selectWidgetType,
} from 'app/imports/App.selectors'
import IconLogo from 'assets/img/logo_small.png'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { WidgetTypes } from 'types'
import { LayoutHeaderDistrict } from '../LayoutHeaderDistrict/LayoutHeaderDistrict'
import { LayoutHeaderLeague } from '../LayoutHeaderLeague/LayoutHeaderLeague'
import { LayoutHeaderSchool } from '../LayoutHeaderSchool/LayoutHeaderSchool'
import { LayoutHeaderState } from '../LayoutHeaderState/LayoutHeaderState'
import * as Styled from './LayoutHeader.styled'

export function LayoutHeader() {
  const widgetType = useSelector(selectWidgetType)
  const widgetTitle = useSelector(selectWidgetTitle)
  const widgetTitleFontSize = useSelector(selectWidgetTitleFontSize)
  const hasMultipleIds = useSelector(getFiltersHasMultipleIds)

  const title = useMemo(() => {
    if (widgetTitle || hasMultipleIds) {
      return (
        <>
          <title>{widgetTitle ? `Scoreboard | ${widgetTitle}` : 'Scoreboard'}</title>
          {widgetTitle}
        </>
      )
    }

    if (widgetType === WidgetTypes.State || widgetType === WidgetTypes.StateLeague) {
      return <LayoutHeaderState />
    }

    if (widgetType === WidgetTypes.League) {
      return <LayoutHeaderLeague />
    }

    if (widgetType === WidgetTypes.District) {
      return <LayoutHeaderDistrict />
    }

    if (widgetType === WidgetTypes.School) {
      return <LayoutHeaderSchool />
    }

    return ''
  }, [widgetTitle, widgetType, hasMultipleIds])

  return (
    <Styled.HeaderContainer>
      <Styled.TitleContainer>
        <Styled.LabelContainer>
          <Styled.Label>Presented by CSZ Network</Styled.Label>
          <Styled.Logo src={IconLogo} alt="" />
        </Styled.LabelContainer>

        <Styled.Title $size={widgetTitleFontSize}>{title}</Styled.Title>
      </Styled.TitleContainer>

      <FiltersCalendarContainer />
    </Styled.HeaderContainer>
  )
}
